if (typeof console === "undefined") {
    console = {
        log: function (n) {
            //debugging
            return;
        }
    };
}

function Utils() {
}

Utils.prototype.splitWithTail = function(str,delim,count){
    var parts = str.split(delim);
    var tail = parts.slice(count).join(delim);
    var result = parts.slice(0,count);
    result.push(tail);
    return result;
}

Utils.prototype.parseQueryString = function (queryString) {
    // define an object to contain the parsed query data
    var result = {};
    var origQueryString = queryString;
    //if the query string still has the ?, check to see if it still has the URL attached to it. if so then strip off the URL
    if (queryString.indexOf("?") != -1) {
        if (this.splitWithTail(queryString, "?", 1)[0]) {
            queryString = this.splitWithTail(queryString, "?", 1)[1];
        }
    }

    // remove the leading question mark from the query string if it is present
    if (queryString.charAt(0) == '?') queryString = queryString.substring(1);

    // replace plus signs in the query string with spaces
    queryString = queryString.replace('+', ' ');

    // split the query string around ampersands and semicolons
    var queryComponents = queryString.split(/[&;]/g);

    // loop over the query string components
    for (var i = 0; i < queryComponents.length; i++) {
        // extract this component's key-value pair
        if (queryComponents[i].indexOf('=') != -1) {
            var keyValuePair = queryComponents[i].split('=');
            var key = this.decode(keyValuePair[0]);
            var value = this.decode(keyValuePair[1]);
            // update the parsed query data with this component's key-value pair
            if (!result[key]) result[key] = [];
            result[key].push((keyValuePair.length == 1) ? '' : value);
        }
        else {
            //if we are are here the either there is no querystring or there is just a "?" and nothing else
            if (origQueryString.indexOf("?") != -1) {
                result["NULL"] = [];
                result["NULL"].push(origQueryString.split("?")[1]);
            }
            else {
                alert("no querystring contained in \n " + queryComponents + " loaded from " + document.location.href)
                return "";
            }
        }
    }

    // return the parsed query data
    return result;
};

Utils.prototype.decode = function (str) {
    return unescape(str.replace(/\+/g, " "));
};

if (!Function.prototype.bind) {
  Function.prototype.bind = function(oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // Function.prototype doesn't have a prototype property
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
  };
}
